import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  button: {
    marginBottom: "15px",
  },
  authButtonIcon: {
    marginRight: "10px",
  },
  contentWrapper: {
    justifyContent: "center",
    textTransform: "none",
    whiteSpace: "nowrap",
  },
}));
